<script>
import AppDoubleInput from '@/components(new)/UI/Forms/InputDouble/InputDouble.vue'
import InputSelect from '@/components(new)/UI/Forms/InputSelect/InputSelect.vue'
import Label from '@/components(new)/UI/Forms/Label/Label.vue'
import onlyInputNumbers from '@/components/mixins/OnlyInputNumber'
import Bioinsumos from '@/components(new)/UI/Forms/FormulariosProntos/Bioinsumos/Bioinsumos.vue'
import Irrigacao from '@/components(new)/UI/Forms/FormulariosProntos/Irrigacao/Irrigacao.vue'
import Financiamentos from '@/components(new)/UI/Forms/FormulariosProntos/Financiamentos/Financiamentos.vue'
import { opcoesGrauDegradacao, opcoesSimNao, opcoesTecnicaRecuperacao } from '@/libs/constants/praticas/opcoesSelects'

export default {
  components: {
    AppDoubleInput,
    Label,
    InputSelect,
    Bioinsumos,
    Irrigacao,
    Financiamentos
  },
  mixins: [onlyInputNumbers],
  props: {
    pratica: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      nomeAba: 'Práticas',
      opcoesGrauDegradacao,
      opcoesSimNao,
      opcoesTecnicaRecuperacao
    }
  },
  methods: {
    containsOption (lista, option, model) {
      if (!lista) return false
      const contains = lista.includes(option)
      if (!contains) this.pratica[model] = null
      return contains
    }
  }
}
</script>
<template>
  <div class="prpd">
    <el-row :gutter="20">
      <validation-provider
        rules="area"
        v-slot="{ errors }"
        mode="lazy"
        :name="`${nomeAba}/Área destinada à recuperação`"
      >
        <el-col :span="8">
          <Label
            label="Área destinada à recuperação"
            :obrigatorio="true"
          />
          <AppDoubleInput
            name="Área destinada à recuperação"
            v-model="pratica.areaDestinada"
            :precision="2"
            :onkeypress="onlyInputNumbers"
            :showAppend="true"
            :class="{'input erro' : errors.length}"
          />
          <span v-if="errors[0]" class="help erro"> {{ errors[0] }}</span>
        </el-col>
      </validation-provider>
      <validation-provider
        rules="required"
        v-slot="{ errors }"
        mode="lazy"
        :name="`${nomeAba}/Data início da recuperação`"
      >
        <el-col :span="10">
          <Label
            label="Data de início do processo de recuperação"
            :obrigatorio="true"
          />
          <el-date-picker
            v-model="pratica.dataInicio"
            type="month"
            placeholder="Selecione mês e ano"
            format="MM/yyyy"
            value-format="yyyy-MM-dd"
            style="width: 100%"
            :class="{'input erro' : errors.length}"
          />
          <span v-if="errors[0]" class="help erro"> {{ errors[0] }}</span>
        </el-col>
      </validation-provider>
    </el-row>
    <el-row :gutter="20">
      <InputSelect
        label="Grau de degradação da área"
        v-model="pratica.grauDegradacao"
        :nomeAba="nomeAba"
        :obrigatorio="true"
        rulesInput="required"
        :opcoes="opcoesGrauDegradacao"
        :widthColumn="8"
      />
      <InputSelect
        label="Foi realizada análise de solo antes da recuperação?"
        v-model="pratica.hasAnaliseSolo"
        :nomeAba="nomeAba"
        :obrigatorio="true"
        rulesInput="required"
        :opcoes="opcoesSimNao"
        :widthColumn="10"
      />
    </el-row>
    <el-row :gutter="20">
      <InputSelect
        label="Técnica(s) utilizada(s) na recuperação da área"
        v-model="pratica.tecnicasUtilizadas"
        multiSelect
        :nomeAba="nomeAba"
        rulesInput="required"
        :obrigatorio="true"
        :opcoes="opcoesTecnicaRecuperacao"
        :widthColumn="10"
      />
      <validation-provider
        v-if="containsOption(pratica.tecnicasUtilizadas, 'OUTROS', 'outrosTecnicasUtilizadas')"
        rules="required"
        v-slot="{ errors }"
        mode="lazy"
        :name="`${nomeAba}/Outros Técnicas Utilizadas`"
      >
        <el-col :span="8">
          <Label
            label="Quais?"
            :obrigatorio="true"
          />
          <el-input
            name="Outras Técnicas de Recuperação"
            v-model="pratica.outrosTecnicasUtilizadas"
            :class="{'input erro' : errors.length}"
          />
          <span v-if="errors[0]" class="help erro"> {{ errors[0] }}</span>
        </el-col>
      </validation-provider>
    </el-row>

    <Bioinsumos
      :pratica="pratica"
      :nomeAba="nomeAba"
    />

    <Irrigacao
      :pratica="pratica"
      :nomeAba="nomeAba"
    />

    <Financiamentos
      :pratica="pratica"
      :nomeAba="nomeAba"
    />

    <el-row :gutter="20">
    <validation-provider
      v-slot="{ errors }"
      mode="lazy"
      :name="`${nomeAba}/Descrição`"
    >
    <el-col :span="24">
      <Label
        label="Descrição"
      />
      <el-input
        name="Descrição"
        v-model="pratica.descricao"
        :class="{'input erro' : errors.length}"
        type="textarea"
        maxlength="500"
        show-word-limit
      />
      <span v-if="errors[0]" class="help erro"> {{ errors[0] }}</span>
    </el-col>
    </validation-provider>
    </el-row>
  </div>
</template>



// WEBPACK FOOTER //
// src/App/(authenticated)/modulos/cadastro/formulario-cadastro/praticas/form-praticas/PRPD/PRPD.vue